export default __webpack_public_path__ + "static/media/bike-itau.5ca048ed.png";